<template>
  <a-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-table
          ref="table"
          rowKey="id"
          size="middle"
          :columns="columns"
          :dataSource="pointList"
          :pagination="false"
          :loading="loading"
          bordered>
          <span slot="action" slot-scope="text, recordV">
            <a @click="downLoadData(recordV, '1')" type="button" icon="download" style="margin-left: 8px">Export JSON</a>
            <a-divider type="vertical"/>
            <a-popconfirm title="Confirmclear??" @confirm="() =>handleClear(recordV.id)">
              <a>Delete</a>
            </a-popconfirm>
        </span>

        </a-table>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { deleteJsonData } from '@/webpublicapi/customer'
import DictSelect from '../../modules/DictSelect';
import Dict from '@/views/webpublic/modules/Dict.vue'
import exportFile from '@/webpublicapi/exportFile'


// duplicateCheck
export default {
  name: 'TestToolJSONListModal',
  components: {
    Dict,
    DictSelect,
  },
  data () {
    return {
      value: 1,
      title: 'Action',
      visible: false,
      loading: false,
      columns: [
        {
          title: 'id',
          align: 'left',
          dataIndex: 'id',
        },
        {
          title: 'Order No.',
          align: 'left',
          dataIndex: 'orderInfoId',
        },
        {
          title: 'Path',
          align: 'left',
          dataIndex: 'filePath'
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align:"center",
          scopedSlots: { customRender: 'action' },
        }
      ],
      dataSource:[],
      pointList: [],
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
    }
  },
  created () {
  },
  methods: {
    checkBoxChange(checkedValue) {
      console.log(checkedValue)
    },
    add () {
      this.edit({})
    },
    edit (record) {
      if (record.id) {
        this.visiblekey = true
      } else {
        this.visiblekey = false
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.pointList = record.pointList;
      })
    },
    downLoadData (record, type) {
      console.log("record",record)
      const file = {
        fileUrl: '/api/web/webpublic/order/test/getJsonDataById?jsonId=' + record.id + '&type=' + type +'&category=pointjson' ,
        fileName: 'pointjson.json',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    handleClear(id){
      this.confirmLoading = true
      deleteJsonData({jsonFileId: id,type: 'tool'}).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.$emit('ok')
        } else {
          this.$message.warning(res.msg)
        }
      }).finally(() => {
        this.confirmLoading = false
        this.close()
      })
    },
    // Confirm
    handleOk () {
      this.close()
      // const that = this
      // // Trigger form validation
      // this.form.validateFields((err, values) => {
      //   if (!err) {
      //     that.confirmLoading = true
      //     const formData = Object.assign(this.model, values)
      //     let obj
      //     console.log(formData)
      //     obj = editInstallmentOrderStatusForTest(formData)
      //     obj.then((res) => {
      //       if (res.code === 1000) {
      //         this.$message.success(res.msg)
      //         this.$emit('ok')
      //       } else {
      //         this.$message.warning(res.msg)
      //       }
      //     }).finally(() => {
      //       this.confirmLoading = false
      //       this.close()
      //     })
      //   }
      // })
    },
    // Close
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
